import moment from 'moment-jalaali';
import { holidaysApi } from './api';
import {
  buildNationalHolidayMap,
  holidayDateToJalaliKey,
} from './persianHolidayDates';
import { IRAN_NATIONAL_HOLIDAYS } from '../data/iranNationalHolidays';
import { enrichHolidayMapTitles } from './holidayApiClient';

let holidaysMapCache = null;
let holidaysLoadPromise = null;

const getYearRange = () => {
  const currentYear = moment().jYear();
  const years = [];
  for (let y = currentYear - 2; y <= currentYear + 3; y += 1) {
    years.push(y);
  }
  return years;
};

const buildHolidayMap = (apiItems = []) => {
  const years = getYearRange();
  const map = buildNationalHolidayMap(years);

  (apiItems || []).forEach((holiday) => {
    const key = holidayDateToJalaliKey(holiday?.date);
    if (!key) return;
    const title = holiday.occassion || holiday.occasion || 'تعطیل شرکتی';
    const existing = map.get(key);
    map.set(key, existing ? `${existing} / ${title}` : title);
  });

  return map;
};

const keysNeedingApiTitles = (map, years) => {
  const keys = [];
  years.forEach((year) => {
    if (IRAN_NATIONAL_HOLIDAYS[year]) return;
    for (let month = 1; month <= 12; month += 1) {
      const daysInMonth = moment.jDaysInMonth(year, month - 1);
      for (let day = 1; day <= daysInMonth; day += 1) {
        const key = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        if (!map.has(key)) continue;
        const title = map.get(key);
        if (!title || title === 'تعطیل رسمی') keys.push(key);
      }
    }
  });
  return keys;
};

/** بارگذاری و کش تعطیلات (رسمی ملی + شرکتی) */
export const getPersianHolidaysMap = async () => {
  if (holidaysMapCache) return holidaysMapCache;

  const authToken = localStorage.getItem('authToken');
  if (!authToken) {
    const years = getYearRange();
    holidaysMapCache = buildNationalHolidayMap(years);
    await enrichHolidayMapTitles(holidaysMapCache, keysNeedingApiTitles(holidaysMapCache, years));
    return holidaysMapCache;
  }

  if (!holidaysLoadPromise) {
    holidaysLoadPromise = holidaysApi
      .getAll({}, { skipAuthRedirect: true })
      .then(async (res) => {
        const items = res?.data || res?.holidays || [];
        const years = getYearRange();
        holidaysMapCache = buildHolidayMap(items);
        await enrichHolidayMapTitles(holidaysMapCache, keysNeedingApiTitles(holidaysMapCache, years));
        return holidaysMapCache;
      })
      .catch(async () => {
        const years = getYearRange();
        holidaysMapCache = buildNationalHolidayMap(years);
        await enrichHolidayMapTitles(holidaysMapCache, keysNeedingApiTitles(holidaysMapCache, years));
        return holidaysMapCache;
      });
  }

  return holidaysLoadPromise;
};

export const invalidatePersianHolidaysCache = () => {
  holidaysMapCache = null;
  holidaysLoadPromise = null;
};
